import type { Campaign } from '@/data'
import type { PaginatedResponse, ListParams } from '@/api/client'
import { buildQuery } from '@/api/client'
import api from '..'

export type PaginatedCampaigns = PaginatedResponse<Campaign>

export async function getCampaigns(
  params?: ListParams,
): Promise<PaginatedCampaigns> {
  const res = await api.get('/campaigns', { params: buildQuery(params) })
  return { data: res.data.data, meta: res.data.meta }
}
